<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal [customTitle]="(id ? 'Editar' : 'Nueva') + ' oficina'" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-4">

        <custom-input [autofocus]="true" label="Nombre" type="text" [formControlItem]="saveForm.get('name')">
        </custom-input>

        <custom-input label="Serie facturación" type="text" [formControlItem]="saveForm.get('prefix')">
        </custom-input>

        <custom-input label="Inicio de secuencia" type="number" [formControlItem]="saveForm.get('sequence_start')">
        </custom-input>

        <custom-input label="Inicio de secuencia (abono)" type="number"
            [formControlItem]="saveForm.get('sequence_start_refund')">
        </custom-input>

    </form>
</app-custom-modal>
}
